<template>
  <div class="container">
    <h3 class="title is-3 has-text-centered">Welcome back to ShareDocView</h3>
    <p class="has-text-centered has-text-grey has-margin-bottom-1">
      <em>What interesting documents are we going to share today?</em>
    </p>
    <div class="columns is-centered">
      <div class="column is-one-third">
        <div class="notification is-danger" v-if="generalError">
          {{ generalError }}
        </div>
        <login-form
          class="has-margin-bottom-1"
          :showError="false"
          @onError="generalError = $event"
        />
        <div class="field">
          <router-link to="/reconfirm" class="link has-text-grey">
            Resend confirmation email
          </router-link>
        </div>
        <div class="is-divider" data-content="OR"></div>
        <div class="field">
          <a
            class="button button-linkedin is-fullwidth"
            :href="`/api/users/auth/linkedin${queries}`"
          >
            <span class="icon">
              <i class="fab fa-linkedin"></i>
            </span>
            <span>Sign in with LinkedIn</span>
          </a>
        </div>
        <div class="field">
          <a
            class="button button-google is-fullwidth"
            :href="`/api/users/auth/google${queries}`"
          >
            <span class="icon">
              <i class="fab fa-google"></i>
            </span>
            <span>Sign in with Google</span>
          </a>
        </div>
        <div class="is-divider" data-content="Don't have an account?"></div>
        <div class="field">
          <router-link
            :to="`/register${queries}`"
            class="button is-fullwidth is-success"
          >
            Register Here
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  components: {
    LoginForm: () => import('@/components/shared/Login')
  },
  data() {
    return {
      generalError: ''
    };
  },
  computed: {
    queries() {
      let params = [];
      if (this.$route.query?.from) {
        params.push(`returnTo=${this.$route.query.from}`);
      } else if (this.$route.query?.returnTo) {
        params.push(`returnTo=${this.$route.query.returnTo}`);
      }
      if (this.$route.query?.plan) {
        params.push(`plan=${this.$route.query.plan}`);
      }
      params = params.join('&');
      params = params.length ? '?' + params : '';
      return params;
    }
  }
};
</script>
